module.exports = "/_next/static/images/b015cf78f12d1df0165255813491e089-nuconta-inclined-device@0.5x.png";